module.exports = __webpack_public_path__ + "static/WEDDING E&M-314-6bdb104c4410a1733b1662afccd9550a.jpg";